import { asyncLoader } from './AsyncLoader'
class SearchListener {
	container
	input
	reset
	btn

	setSearchUrl (searchBaseUrl) {
		this.searchBaseUrl = searchBaseUrl
	}

	setContainer (container) {
		this.container = container
		this.addListener()
	}

	setButton (button) {
		this.btn = button
	}

	setReset (reset) {
		this.reset = reset
	}

	setInput (input) {
		this.input = input
	}

	addListener () {
		this.btn.addEventListener('click', this._listenToClick.bind(this))
		this.reset.addEventListener('click', this._resetForm.bind(this))
		this.input.addEventListener('keypress', this._listenToEnter.bind(this))
	}

	async _resetForm () {
		this.input.value = ''
	}

	async _listenToEnter (e) {
		if (this.input.value.length < 3) return false
		if (e.key !== 'Enter') return false
		this._listenToClick()
	}

	async _listenToClick () {
		if (asyncLoader.status === 'IN_PROGRESS') return false
		if (this.input.value.length < 3) return false
		asyncLoader.reset()
		this.post = []
		asyncLoader.setStatus('IN_PROGRESS')

		const nextURL = this.searchBaseUrl + '?search=' + this.input.value
		const nextState = { additionalInformation: 'Updated the URL with JS' }

		window.history.replaceState(nextState, document.title, nextURL)
		await asyncLoader.loadMorePosts()
		asyncLoader.setStatus('DONE')
	}
}

const searchListener = new SearchListener()
export { SearchListener, searchListener }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/com_catalog_search_async/core/SearchListener.js